import styled from "styled-components";

export const Wrapper = styled.div`
  font: small-caps bold 24px/1 sans-serif;
  margin: 0 var(--right-left-margin);
  text-align: center;
  line-height: 180%;
`;

